module.exports = __webpack_public_path__ + "omniv2/img/icon-money-dark.cb8c1b74.svg";